import { render, staticRenderFns } from "./MisConstancias.vue?vue&type=template&id=98c41a88&scoped=true"
import script from "./MisConstancias.vue?vue&type=script&lang=js"
export * from "./MisConstancias.vue?vue&type=script&lang=js"
import style0 from "./MisConstancias.vue?vue&type=style&index=0&id=98c41a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c41a88",
  null
  
)

export default component.exports